import { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { Star } from "lucide-react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const PROGRAM_COLORS = {
  StenoU: "#38b6ff",
  EditU: "#E8E8E8",
  ProofU: "#38b6ff",
};

export default function TestimonialsSection() {
  const [testimonials, setTestimonials] = useState([]);

  useEffect(() => {
    axios.get(`${API}/testimonials`).then(r => setTestimonials(r.data)).catch(() => {});
  }, []);

  if (!testimonials.length) return null;

  return (
    <section className="py-20 md:py-28 bg-section-alt" data-testid="testimonials-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <p
            className="text-xs font-bold uppercase tracking-[0.2em] text-[#38b6ff] mb-4"
            style={{ fontFamily: 'JetBrains Mono, monospace' }}
          >
            Student Success
          </p>
          <h2
            className="text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-[#F5F5F7]"
            style={{ fontFamily: 'Unbounded, sans-serif' }}
          >
            Hear From Our <span className="gradient-text">Graduates</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {testimonials.map((t, i) => (
            <motion.div
              key={t.id}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.1 }}
              className="glass-card p-6 flex flex-col"
              data-testid={`testimonial-${t.id}`}
            >
              <div className="flex gap-1 mb-4">
                {[...Array(5)].map((_, j) => (
                  <Star key={j} className="w-4 h-4 fill-[#38b6ff] text-[#38b6ff]" />
                ))}
              </div>
              <p className="text-[#E0E0E0] text-sm leading-relaxed flex-1 mb-6 italic">
                &ldquo;{t.quote}&rdquo;
              </p>
              <div className="flex items-center gap-3 pt-4 border-t border-white/10">
                <div
                  className="w-10 h-10 rounded-full flex items-center justify-center text-sm font-bold"
                  style={{
                    backgroundColor: `${PROGRAM_COLORS[t.program] || "#38b6ff"}20`,
                    color: PROGRAM_COLORS[t.program] || "#38b6ff",
                    border: `1px solid ${PROGRAM_COLORS[t.program] || "#38b6ff"}40`
                  }}
                >
                  {t.name.charAt(0)}
                </div>
                <div>
                  <p className="text-sm font-medium text-[#F5F5F7]">{t.name}</p>
                  <p className="text-xs text-[#B0B0B0]">{t.role} &middot; {t.program}</p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
